import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FaqService } from './faq.service';

@Component({
  selector: 'kt-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  public searchBy: string = "serviceName";
  public spinner: boolean = false;
  public ticketNoPlaceHolder: string = "e.g. 24644 ";
  public CNICPlaceHolder: string = "e.g. 1223442456644 ";
  public pageLoad: boolean = true;
  private letters = /[A-Za-z]/;
  public isViewRemarkBtnDisable = false;
  public numberOfSearches: number=0;
  public searchTicket : boolean = true;
  public showFaqs : boolean = false;
  public departmentTreeServiceList = [];
  public selectedValue="";
  public faqData: any;
  public config: any;
  public faqIds: any=[];
  public showNoRecord= false;

  constructor(private faqServices: FaqService, private ref: ChangeDetectorRef,) {
      
     }

  ngOnInit() {
    this.getServiceList();
  }

  changeSearchStatus(status) {
    this.searchBy = status;
    if(this.searchBy == 'keywords'){
    // this.gaService.sendPageEvent('SEARCH FAQ BY KEYWORDS | FAQ', 'Tap');     
    }else if(this.searchBy == 'serviceName'){
      // this.gaService.sendPageEvent('SEARCH FAQ BY SERVICE NAME | FAQ', 'Tap');     
    }
  }

  pageChanged(event){
    this.config.currentPage = event;
  }
  
  async serachFAQ(value: string) {
    // this.gaService.sendPageEvent('SEARCH FAQ | FAQ', 'Tap');
    if(value != 'null'){
    await this.searchResults(value);
    if(this.faqData.length){      
      // this.spinner = false;
    }
  }
}

  searchResults(value:string){
    return new Promise((resolve, reject) => {
      let payload = {
        service: this.searchBy == 'serviceName' ? value : null,
        tag: this.searchBy == 'keywords' ? value : null
      }    
      this.spinner = true;
      this.faqServices.getFaqsList(payload).subscribe((res: any) => {
        if (res.statusCode == "200") {
          for(let i=0; i < res.data.length; i++){
            res.data[i].questions = res.data[i].questions.replace(/�/g,"-");
            res.data[i].answer = res.data[i].answer.replace(/�/g,"-");
          }   
          this.spinner = false;        
          this.faqIds = res.data;  
          this.faqData = res.data;                
         this.showNoRecord = false;
          this.showFaqs= true;    
          if(this.faqData.length > 0){
          this.config = {
            itemsPerPage: 15,
            currentPage: 1,
            totalItems: this.faqData.length
          };
          if (!this.ref['destroyed']) { this.ref.detectChanges(); }    
        }
          resolve(this.faqData);
        
      }else if(res.statusCode == "100"){
        this.faqData = '';
        this.spinner = false;        
        this.showFaqs = false;
        this.showNoRecord = true;
        if (!this.ref['destroyed']) { this.ref.detectChanges(); }   
         
        
      }
    }
      )
    })
    .catch(function (error) {
      console.log(error)
    })
  }
  

public getServiceList() {
  this.faqServices.getDepartmentTreeServicesList().subscribe((res: any) => {
    if(res.statusCode == 200){
    this.departmentTreeServiceList = res.data;
    this.selectedValue = '1~1~1';
    this.searchResults(this.selectedValue)
    if (!this.ref['destroyed']) { this.ref.detectChanges(); }
  }
  },
    error => {
    });
}

}